/**
 * @desc 列表
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(params: API.business.paymentOrder.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
